import { render, staticRenderFns } from "./VDatePublication.vue?vue&type=template&id=c2abc5a8&"
import script from "./VDatePublication.vue?vue&type=script&lang=js&"
export * from "./VDatePublication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports